const PaymentMethods = [
    {key: "cash", text: "Cash"},
    {key: "transfer", text: "Bank Transfer"},
    {key: "virtualaccount", text: "Virtual Account"},
    {key: "deposit", text: "Deposit"}
];

export default PaymentMethods;